export default "__VITE_ASSET__BiyF93dK__"